(() => {
  if (window.__rmsAzFilterLoaded) return;
  window.__rmsAzFilterLoaded = true;

  const normalizeName = (value) =>
    String(value || '')
      .normalize('NFKC')
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const OTHER_ARTISTS = new Set(["AC/DC","Al Di Meola","Al Hendrickson","Al Qantarah","Aldo Zunino","Alessandro Lanzoni","Alessandro Presti","Alessia Martegiani","Alexis Cole","Ana Caram","Andrea Pozza","Antonella Vitale","Astor Piazzolla","Battista Lena","The Beau Hunks Orchestra","Beppe Danese","Bill Evans","Black Sabbath","Bob Bain","Boris Karloff","Brian Wilson","Cannonball Adderley","Canzoniere del Lazio","Casey Abrams","Chick Corea","Christy Baron","Clark Terry","Claudio Fasoli","Clyde Hager","David Bowie","David Gilmour","Deep Purple","Dexter Gordon","Donald Cherry","Dream Theater","Ed Blackwell","Eleonora Bianchini","Elvis Presley","Enrico Merlin","Enrico Rava","Enzo Pietropaoli","Eraldo Bernocchi","Eugenio Finardi","Fabio Accurso","Fabio Tricomi","Fabrizio Bosso","Fabrizio Mandolini","Faisal Taher","Farzaneh Joorabchi","Fausto Mesolella","Ferruccio Spinetti","Finaz","Franco Battiato","Fulvio Sigurtà","Gabriele Mirabassi","Gaby Cole","Gary Green","Gerry Mulligan","Giampaolo Casati","Giorgio Alderighi","Giuseppe De Trizio","Giusto Pio","Harry Belafonte","Henry Mancini","Horace Silver","Italian Big Band","James Leary","Joe Reisman","John Coltrane","John Hackett","John Lennon","John Scofield","Johnny Cash","Julian Mazzariello","Kate McGarry","Keith Jarrett","Lee Morgan","Livingston Taylor","Lou Reed","Luca Bulgarelli","Luciano Biondini","Macy Gray","Malcolm Mortimore","Marcello Di Leonardo","Marco Lo Muscio","Marta Gómez","Matteo Bortone","Matteo Mancuso","Max Prandi","McCoy Tyner","Michel Petrucciani","Michele Ascolese","Michele Rabbia","Miles Davis","Miles Davis Quintet","Mimì Ciaramella","Modern Jazz Quartet","Munyungo Jackson","Nick Mason","Nico Staiti","Nino Frasio","Ornette Coleman","Ozzy Osbourne","Paolo Birro","Paolo Fresu","Paul Chambers","Peter Gabriel","Petra Magoni","Pink Floyd","Prince","Raiz","Raiz & Radicanto","Rebecca Pidgeon","Red Garland","Riccardo Maggitti","Riccardo Zegna","Richard Wright","Rita Marcotulli","Robert Fripp","Roberto Bolelli","Roberto Della Vecchia","Roberto Gatto","Roberto Gatto Quartet","Roberto Jonata","Roger Waters","Salmo","Salvatore Russo","Sam Rivers","Sara K.","Scott Hamilton","Scott LaFaro","Sonny Rollins","Stefano Bollani","Stefano Concordia","Steve Hackett","Steve Lacy","Syd Barrett","Tinere Harpa","Todd Cochran","Toni Fidanza","Triosfere","Valerie Joyce","The Velvet Underground","Vijay Iyer"].map(normalizeName));
  const OTHER_COMPOSERS = new Set(["Antônio Carlos Jobim","Astor Piazzolla","Bob Dylan","Bruno Canfora","Burt Bacharach","Duke Ellington","Ennio Morricone","George Gershwin","Giusto Pio","Harold Arlen","Henry Mancini","Johnny Mandel","Nicola Piovani","Nino Rota","Richard Rodgers","Thelonious Monk","Vinícius de Moraes"].map(normalizeName));

  const locale = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  const dictionary = {
    it: { classical: 'Musica classica', other: 'Altri generi', group: 'Categoria' },
    en: { classical: 'Classical music', other: 'Other genres', group: 'Category' },
    de: { classical: 'Klassische Musik', other: 'Andere Genres', group: 'Kategorie' },
    es: { classical: 'Música clásica', other: 'Otros géneros', group: 'Categoría' }
  };
  const labels = dictionary[locale] || dictionary.it;

  const ensureStyles = () => {
    if (document.getElementById('rms-az-filter-styles')) return;
    const style = document.createElement('style');
    style.id = 'rms-az-filter-styles';
    style.textContent = `
      .rms-az-filters {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin: 0 0 2.5rem;
      }
      .rms-az-filter {
        appearance: none;
        min-height: 4.2rem;
        padding: .9rem 1.8rem;
        border: .1rem solid #866B2F;
        background: transparent;
        color: #866B2F;
        font: inherit;
        font-size: 1.35rem;
        font-weight: 600;
        letter-spacing: .02em;
        cursor: pointer;
        transition: background-color .18s ease, color .18s ease, border-color .18s ease;
      }
      .rms-az-filter:hover,
      .rms-az-filter:focus-visible {
        background: rgba(134, 107, 47, .08);
      }
      .rms-az-filter.is-active {
        background: #866B2F;
        color: #fff;
      }
      .rms-az-filter.is-active:hover,
      .rms-az-filter.is-active:focus-visible {
        background: #725a27;
        border-color: #725a27;
      }
      .rms-az-filter__count {
        margin-left: .55rem;
        opacity: .72;
        font-size: .9em;
      }
      .rms-artists-az__letter.is-disabled,
      .rms-composers-az__letter.is-disabled {
        opacity: .25;
        pointer-events: none;
      }
      .rms-artist-group[hidden],
      .rms-composer-group[hidden],
      .rms-artist-group__item[hidden],
      .rms-composer-group__item[hidden] {
        display: none !important;
      }
      @media screen and (max-width: 749px) {
        .rms-az-filters {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          gap: .8rem;
          margin-bottom: 2rem;
        }
        .rms-az-filter {
          width: 100%;
          min-height: 4.4rem;
          padding: .8rem .9rem;
          font-size: 1.2rem;
          line-height: 1.25;
        }
        .rms-az-filter__count {
          display: block;
          margin: .25rem 0 0;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const setup = (root, type) => {
    if (!root || root.dataset.rmsFilterReady === 'true') return;
    root.dataset.rmsFilterReady = 'true';

    const isArtist = type === 'artists';
    const itemSelector = isArtist ? '.rms-artist-group__item' : '.rms-composer-group__item';
    const nameSelector = isArtist ? '.rms-artist-group__name' : '.rms-composer-group__name';
    const groupSelector = isArtist ? '.rms-artist-group' : '.rms-composer-group';
    const letterSelector = isArtist ? 'a.rms-artists-az__letter' : 'a.rms-composers-az__letter';
    const introSelector = isArtist ? '.rms-artists-az__intro' : '.rms-composers-az__intro';
    const otherNames = isArtist ? OTHER_ARTISTS : OTHER_COMPOSERS;

    const items = Array.from(root.querySelectorAll(itemSelector));
    if (!items.length) return;

    items.forEach((item) => {
      const name = item.querySelector(nameSelector)?.textContent || '';
      item.dataset.rmsCategory = otherNames.has(normalizeName(name)) ? 'other' : 'classical';
    });

    const counts = {
      classical: items.filter((item) => item.dataset.rmsCategory === 'classical').length,
      other: items.filter((item) => item.dataset.rmsCategory === 'other').length
    };

    const controls = document.createElement('div');
    controls.className = 'rms-az-filters';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', labels.group);

    ['classical', 'other'].forEach((category) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rms-az-filter';
      button.dataset.rmsFilter = category;
      button.setAttribute('aria-pressed', category === 'classical' ? 'true' : 'false');

      const label = document.createElement('span');
      label.textContent = labels[category];

      const count = document.createElement('span');
      count.className = 'rms-az-filter__count';
      count.textContent = `(${counts[category]})`;

      button.append(label, count);
      controls.appendChild(button);
    });

    const intro = root.querySelector(introSelector);
    if (intro) intro.insertAdjacentElement('afterend', controls);
    else root.prepend(controls);

    const letterLinks = Array.from(root.querySelectorAll(letterSelector));

    const applyFilter = (category) => {
      items.forEach((item) => {
        item.hidden = item.dataset.rmsCategory !== category;
      });

      root.querySelectorAll(groupSelector).forEach((group) => {
        const hasVisibleItems = Array.from(group.querySelectorAll(itemSelector)).some((item) => !item.hidden);
        group.hidden = !hasVisibleItems;
      });

      letterLinks.forEach((link) => {
        const href = link.getAttribute('href') || '';
        const target = href.startsWith('#') ? document.getElementById(href.slice(1)) : null;
        const disabled = !target || target.hidden;
        link.classList.toggle('is-disabled', disabled);
        link.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        link.tabIndex = disabled ? -1 : 0;
      });

      controls.querySelectorAll('.rms-az-filter').forEach((button) => {
        const active = button.dataset.rmsFilter === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    controls.addEventListener('click', (event) => {
      const button = event.target.closest('.rms-az-filter');
      if (!button) return;
      applyFilter(button.dataset.rmsFilter);
    });

    letterLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    });

    applyFilter('classical');
  };

  const init = () => {
    ensureStyles();
    setup(document.querySelector('.rms-artists-az'), 'artists');
    setup(document.querySelector('.rms-composers-az'), 'composers');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
